module.exports = __webpack_public_path__ + "static/media/emptyerror.336c7373.png";